import Vue from 'vue'

/**
 * @author Jorge Nunez L. <jorge.nunez@jbge.com.mx>
 * Fetches special concepts for MP
 * @return {Array}
 */

const paramsTransformer = ({
  name, id, slug, code
}) => {
  return {
    name,
    id,
    slug,
    code
  }
}

export default () =>
  Vue.$http.get(`sinister/list/sinister-cancellation-type/`)
    .then(response => response.data.map(paramsTransformer).sort((a, b) => (a.name <= b.name ? -1 : 1)))
